import React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import "../../css/table.css";
import { get } from "lodash";
import { getComparator, stableSort, TableComponent } from "../../Common/Table";
import { useState } from "react";
import { IoEye } from "react-icons/io5";
import SelectDropdown from "../../Common/SelectDropdown";
import { budgetTableHeader } from "../../Fields/budgetFields";
import { useMediaQuery } from "react-responsive";
import TableCard from "../../Common/TableCard";
import {
  Grid,
  Card,
  Paper,
  Container,
  CardHeader,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
export default function BudgetList({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  totalGrantedAmount,
  totalRequestedAmount,
  page,
  setPage,
  onEdit,
  onView,
  onStepperForm,
  register,
  errors,
}) {
  const isTabletMid = useMediaQuery({ query: "(max-width: 768px)" });
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [searchVal, setSearchVal] = useState("");
  const headers = budgetTableHeader;
  const { role } = useSelector((state) => state.user);

  const handleChangePage = async (event, newPage) => {
    console.log("new page: " + newPage);
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage, "");
  };

  const handleChangeRowsPerPage = (event) => {
    console.log("event" + event.target.value);
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value), "");
  };

  const handleSearchFieldDropdown = (e) => {
    if (searchVal) {
      getListData(1, rowsPerPage, searchVal, e.target.value);
    }
  };

  const componentDisplay = () => {
    const cells = headers?.filter(
      (cell) =>
        cell.id === "requestNumber" ||
        cell.id === "requestCreatedBy" ||
        cell.id === "designation" ||
        cell.id === "requestedAmount" ||
        cell.id === "grantedAmount"
    );
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-96">
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-3 w-48 border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };
  const statusStyles = {
    new: {
      text: "#2f4b7c",
      bg: "#e0e6f5", // light shade of #2f4b7c
    },
    inprogress: {
      text: "#f28927",
      bg: "#fde9d1", // light shade of #f28927
    },
    OnHold: {
      text: "#f26033",
      bg: "#fbded7", // light shade of #f26033
    },
    resolved: {
      text: "#5D883C",
      bg: "#e2f0db", // light shade of #5D883C
    },
    rejected: {
      text: "#000",
      bg: "#f0f0f0", 
    },

  };
  return (
    <React.Fragment>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6}>
            <Card
              className="flex-auto flex justify-between items-center h-20 m-2 pl-10 pr-10 p-1 border-2 border-blueBg"
              // style={{
              //   background: 'linear-gradient(-20deg,#f89650 0,#f84450 100%)',
              // }}
            >
              <div className="flex items-center">
                <Typography
                  variant="h6"
                  className="text-base lg:text-xl font-bold text-blueBg uppercase"
                >
                  Total Requested Amount
                </Typography>
              </div>
              {/* <div className="h-full bg-blueBg w-1 rounded"></div> */}
              <Typography
                variant="h6"
                className="text-2xl font-bold text-blueBg"
              >
                {totalRequestedAmount}
              </Typography>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Card
              className="flex-auto flex justify-between items-center h-20 m-2 pl-10 pr-10 p-1 border-2 border-blueBg"
              // style={{
              //   background: 'linear-gradient(-20deg,#aabf72 0,#22b573 100%)',
              // }}
            >
              <div className="flex items-center">
                <Typography
                  variant="h6"
                  className="text-base lg:text-xl font-bold text-blueBg uppercase"
                >
                  Total Granted Amount
                </Typography>
              </div>
              {/* <div className="h-full bg-blueBg w-1 rounded"></div> */}
              <Typography
                variant="h6"
                className="text-2xl font-bold text-blueBg"
              >
                {totalGrantedAmount}
              </Typography>
            </Card>
          </Grid>
        </Grid>
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={0}
                searchVal={searchVal}
                headingText={"Budget Details"}
                order={order}
                searchBar={true}
                orderBy={orderBy}
                rowCount={tableRowsData.length || 0}
                tableRowsData={tableRowsData}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getListData}
                componentDisplay={componentDisplay}
              >
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  tableRowsData.map((data) => (
                    <TableCard
                      key={data.requestNumber}
                      requestNumber={data.requestNumber}
                      requestCreatedBy={data.requestCreatedBy}
                      requestedAmount={data?.requestedAmount}
                      requestedDate={data?.requestedDate}
                      grantedAmount={data.grantedAmount}
                      grantedDate={data.grantedDate}
                      status={data.status}
                      allowedRoles={["Super-Admin", "Admin", "editor"]}
                      role={role}
                      onEdit={
                        role === "Super-Admin" ||
                        role === "Admin" ||
                        role === "editor"
                          ? (e) => onStepperForm(data, e)
                          : undefined
                      }
                      onView={
                        role === "Super-Admin" ||
                        role === "Admin" ||
                        role === "editor"
                          ? (e) => onStepperForm(data, e)
                          : undefined
                      }
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Entries per page: "}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div style={{ width: "100%" }}>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              headingText={"Budget Details"}
              order={order}
              searchBar={true}
              orderBy={orderBy}
              rowCount={tableRowsData.length || 0}
              tableRowsData={tableRowsData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getListData}
              componentDisplay={componentDisplay}
            >
              <TableBody className="table-body">
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  stableSort(tableRowsData, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={index}>
                          {headers.map((cell) => {
                            return (
                              <TableCell key={cell.id + index} className={cell.id === 'sno' ? 'sno-column' : ''}>
                                {cell.id === "action" ? (
                                  <div className="justify-around items-center flex">
                                    {/* <div onClick={(e) => onEdit(row)}>
                                      <FaEdit size={20}/>
                                    </div> */}
                                    <div
                                      onClick={(e) => {
                                        if (role !== "user") {
                                          onView(row, e);
                                        }
                                      }}
                                      style={{
                                        pointerEvents:
                                          role === "user" ? "none" : "auto",
                                        opacity: role === "user" ? 0.5 : 1,
                                      }}
                                    >
                                      <IoEye
                                        size={23}
                                        className="cursor-pointer text-blue-600 hover:text-blue-800 transition"
                                      />
                                    </div>
                                  </div>
                                ) : cell.id === "requestNumber" ? (
                                  <div
                                    className="text-xs flex cursor-pointer text-blue-800 hover:font-bold"
                                    // style={{
                                    //   pointerEvents:
                                    //     role === "user" ? "none" : "auto",
                                    //   // opacity: role === "user" ? 0.5 : 1,
                                    // }}
                                  >
                                    <div
                                      onClick={(e) =>
                                        role !== "user" && onStepperForm(row, e)
                                      }
                                    >
                                      {get(row, cell.id)}
                                    </div>
                                  </div>
                                ) : cell.id === "sno" ? (
                                  index + 1
                                ) : cell.id === "status" ? (
                                  <div
                                    className={`capitalize rounded-md px-2 py-1 text-sm font-medium`}
                                    style={{
                                      color:
                                        statusStyles[get(row, cell.id)]?.text ||
                                        "",
                                      backgroundColor:
                                        statusStyles[get(row, cell.id)]?.bg ||
                                        "",
                                    }}
                                  >
                                    {get(row, cell.id)}
                                  </div>
                                ) : (
                                  get(row, cell.id)
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Entries per page: "}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
